import { render, staticRenderFns } from "./addFilmDistributor.vue?vue&type=template&id=73d0b0aa&"
import script from "./addFilmDistributor.vue?vue&type=script&lang=js&"
export * from "./addFilmDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports